import React from 'react';
import ActionsCell from '../../../components/ActionsCell';

export default (gantt, { t }) => ({
  name: 'actions',
  label: t('scheduleofschedule.columns.actions'),
  width: 70,
  onrender: (item) => <ActionsCell project={item} />
});
